
import SetupDesktopHeader from "../../../../../setup/components/SetupDesktopHeader.client"
import SetupActivityBar from "../../../../../setup/components/SetupActivityBar.client"
import { CustomerMetafields } from "~/types"
import { Metafield } from "@shopify/hydrogen/storefront-api-types"

type DesktopHeaderProps = {
    isCartOpen: boolean,
    closeCart: () => void,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    openCart: () => void,
    menuItems: any[]
    showCategory: string | boolean,
    shopSettings: string,
    currency: string,
    customer?: CustomerMetafields,
    tagline?: Metafield;
}

export default function CustomDesktopHeader({ isCartOpen, closeCart, setShowCategory, goTo, openCart, showCategory, menuItems, shopSettings, currency, customer, tagline }: DesktopHeaderProps) {
    return (
        <>
            <SetupActivityBar isCartOpen={isCartOpen} closeCart={closeCart} openCart={openCart} currency={currency} tagline={tagline} />
            {/* setShowCategory, openCart, menuItems, showCategory, shopSettings */}

            <div onMouseLeave={() => setShowCategory(false)} className="hidden lg:block top-0 z-50">
                <SetupDesktopHeader setShowCategory={setShowCategory} openCart={openCart} menuItems={menuItems} showCategory={showCategory} shopSettings={shopSettings} customer={customer} />
            </div>
        </>
    )
}